<ng-container *transloco="let t">
  <div class="flex h-[30rem] flex-col">
    <div class="flex-1">
      <app-sd-targeting-form [existingStrategy]="modalData.strategy" (formChange)="onFormChange($event)" />
    </div>
    <div class="flex justify-end gap-2 border-t border-gray-200 pt-4">
      <button iButton variant="secondary" (click)="modalRef.close()">{{ t("common.cancel") }}</button>
      <button iButton type="submit" [loading]="loading()" [disabled]="!formValue()?.isValid" (click)="onFormSubmit()">
        {{ submitBtnLabel() }}
      </button>
    </div>
  </div>
</ng-container>
